import * as React from 'react';

import { AppStrings } from '~/src/app/modules/strings';
import { FlashMessageContext } from './flash-message.context';

export const useFlashMessage = () => {
  const { showMessage, hideMessage } = React.useContext(FlashMessageContext);

  const showError = React.useCallback(
    (content: string) => {
      showMessage('alert', content ?? AppStrings.General.Error);
    },
    [showMessage],
  );

  const showSuccess = React.useCallback(
    (content: string) => {
      showMessage('success', content);
    },
    [showMessage],
  );

  return { showError, showSuccess, hideMessage };
};
